import { createContext } from "react";
import { DEFAULT_SIBLING_COUNT, DEFAULT_OPTION_HEIGHT, } from "./picker.shared.js";
const PickerContext = createContext({
    siblingCount: DEFAULT_SIBLING_COUNT,
    optionHeight: DEFAULT_OPTION_HEIGHT,
});
export default PickerContext;
